module.exports = __webpack_public_path__ + "static/media/con_spice.877692a3.png";